export enum ChartDataType {
    CONTINUOUS = "CONTINUOUS",
    DISCRETE = "DISCRETE",
}